<template>
  <div class="reviews-carousel">
    <div
      v-if="isLoadingReviews"
      key="loading"
      v-html="loadingHTML"
    />
    <div v-else-if="reviews.length" class="reviews-carousel__inner">
      <Slider classes="size-4" wrapper-class="lav-slider--chevron">
        <template #prev-icon>
          <svg class="icon" aria-hidden="true"><use href="#chevron-left" /></svg>
        </template>
        <template #next-icon>
          <svg class="icon" aria-hidden="true"><use href="#chevron-left" /></svg>
        </template>
        <review-card
          v-for="(review, index) of reviews"
          :key="`${review.id}-${index}`"
          :post="review"
          :show-reply="false"
        />
      </Slider>

      <p class="reviews-carousel__reviews-description">
        {{ texts.showingRatingsText }}
      </p>

      <div
        v-if="!hideNumberOfReviews"
        class="reviews-carousel__platforms"
      >
        <platform-badges
          :average-rating="averageRating"
          :number-of-ratings="numberOfRatings"
          :reviews-url="reviewsUrl"
          :reco-widget-src="recoWidgetSrc"
          :reco-mount-id="recoMountId"
          :google-rating="googleRating"
        />
      </div>
    </div>
    <div v-else />

    <review-modal v-if="modalReview" />
  </div>
</template>

<script>
import Slider from 'Components/Slider.vue';
import { useReviews } from 'Main/composables/useReviews';
import ReviewCard from './ReviewCard.vue';
import PlatformBadges from './PlatformBadges.vue';
import ReviewModal from './ReviewModal.vue';

export default {
  name: 'ReviewsCarousel',

  components: {
    Slider,
    ReviewCard,
    PlatformBadges,
    ReviewModal,
  },

  setup() {
    const {
      reviewsData,
      isLoadingReviews,
      modalReview,
      averageRating,
      numberOfRatings,
      reviews,
      getReviewsSummary,
      openModal,
    } = useReviews();
    return {
      reviewsData,
      isLoadingReviews,
      modalReview,
      averageRating,
      numberOfRatings,
      reviews,
      getReviewsSummary,
      openModal,
    };
  },

  data() {
    const {
      dataset: {
        hideNumberOfReviews,
        reviewsUrl,
        pageType,
        recoWidgetSrc,
        recoMountId,
        googleRating,
      },
    } = this.$mountEl;
    const { innerHTML } = this.$mountElSnapshot;

    return {
      texts: window.theme_vars.trustpilot,
      hideNumberOfReviews: hideNumberOfReviews === 'true' || hideNumberOfReviews === '1',
      reviewsUrl,
      pageType,
      recoWidgetSrc: recoWidgetSrc || '',
      recoMountId: recoMountId || 'reco--badge-2026',
      googleRating: googleRating || '',
      loadingHTML: innerHTML,
    };
  },

  mounted() {
    this.getReviewsSummary(this.pageType);
  },
};
</script>
